import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapActions, mapState } from "pinia";

import { useEditorStore } from "../store/useEditorStore";
import type { ITypeaheadOptions } from "../../../resources-vue/vue-interfaces/i-typeahead";
import { IGetUsersByNameQuery, IUsersList } from "../../../resources-vue/vue-interfaces/messaging-service/i-user";
import { groupNameTooltip } from "../../../resources-vue/vue-tooltips/ChatTooltips";
import { MessageService } from "../../../services/message-service";
import eventBus from "../../../utilities/eventBus";

import TagsInput from "../../../resources-vue/vue-custom-elements/TagsInput/TagsInput.vue";
import ChatSummerEditor from "../../../resources-vue/vue-custom-elements/MessagingService/ChatSummerEditor/ChatSummerEditor.vue";

export default defineComponent({
    components: {
        TagsInput,
        ChatSummerEditor
    },

    data() {
        return {
            _messageService: null as MessageService,
            users: [] as ITypeaheadOptions[],
            groupNameTooltip
        };
    },

    async created() {
        this._messageService = Container.instance.get(MessageService);
    },

    watch: {
        users: {
            handler() {
                this.setNewChatDetails(this.newChatTitle, this.users);
            },
            deep: true
        }
    },

    computed: {
        ...mapState(useEditorStore, ["newChatTitle", "newChatUsers"])
    },

    methods: {
        ...mapActions(useEditorStore, ["setNewChatDetails"]),

        async getUsersList(filter: string, limit: number) {
            const query: IGetUsersByNameQuery = {
                page: 1,
                pageLength: 25,
                term: filter.trim(),
                conversationParticipantUsers: this.newChatUsers.map((user) => user.userId)
            };
            const data = await this._messageService.getUserByName(query);
            return this.getDisplayUsers(data.items);
        },

        getDisplayUsers(data: IUsersList[]) {
            if (data) {
                const filteredItems = data.filter((user) => !this.newChatUsers.includes(user.id));
                return filteredItems.map((user) => ({
                    name: `${user.lastName ? user.lastName + ", " : ""}${user.firstName}`,
                    value: user.id,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    email: user.emailId,
                    emailId: user.emailId, // duplicating as parameter names are different in common component
                    userId: user.id,
                    loginId: user.loginId,
                    currentStatus: user.currentStatus,
                    profileColor: user.profileColor,
                    profilePicId: user.profilePicId,
                    statusMessage: user.statusMessage
                }));
            }
            return [];
        },

        updateTags(value: any) {
            this.users = value;
            if (this.users.length < 2) this.updateTitle(null);
        },

        updateTitle(value: string) {
            const title = value?.trim();
            this.setNewChatDetails(title, this.newChatUsers);
        },
        routeBacktoConnect() {
            eventBus.emit("updateNewConversation", false);
            this.$router.push(`/central-messaging/clinicians/conversation`);
        }
    }
});
